<template>
<div class="card">
   <h6>YOUR CURRENT ENERGY SUPPLY</h6>
   <h4>Gas & Electricity Usage</h4>

   <uiv-tabs justified @change="onUsageTabChange(usageTab)" v-model="usageTab">
      <uiv-tab title="Actual Figures">
        <h6 class="_margin-top-30 _margin-bottom-10">
          Gas <button type="button" class="btn-i" v-if="quote.gasUsage.usageType == 1" v-uiv-tooltip.right="'If you think that your gas consumption is incorrect, please refer to to your latest bill'">i</button>
          <button type="button" class="btn-i" v-if="quote.gasUsage.usageType == 0" v-uiv-tooltip.right="'You will find your gas spend on your latest bill'">i</button>
        </h6>
         <div class="row _margin-bottom-10" v-if="quote.gasUsage.usageType == 1 && gasUsageProvided == quote.gasUsage.usage">
             <div class="col-xs-12">
                 <p class="_margin-bottom-0">Gas consumption is based on your actual annual usage</p>
                 <small v-if="gasUsageProvided">(Check that you are happy with gas kWh consumption provided)</small>
                 <uiv-btn v-uiv-popover.hover-focus.bottom="{ content: 'We\'ve got this information from your supplier via Xoserve. We don\'t have any sensitive data, just your gas usage which helps us give you more accurate prices.' }" type="link" size="xs">How do we know this?</uiv-btn>
             </div>
         </div>

         <div class="row _margin-bottom-20">
            <div class="col-sm-4 _margin-bottom-10">
               <label for="bothUsageGasUsageType" class="sr-only">Usage Type</label>
               <select-list
                  id="bothUsageGasUsageType"
                  v-model="quote.gasUsage.usageType"
                  :list="usageTypeList"
                  @change="onReset()"
               />
            </div>

            <div class="col-xs-12 col-sm-3 _margin-bottom-10">
               <validation-messages label="Spend" :$v="$v.gasUsage.cost" v-if="quote.gasUsage.usageType == 0">
                  <label for="bothUsageGasCost" class="sr-only">Gas Cost</label>
                  <div class="input-group left">
                     <div class="input-group-addon">£</div>
                     <form-field
                        id="bothUsageGasCost"
                        type="number"
                        v-model="quote.gasUsage.cost"
                        :error="$v.gasUsage.cost.$error"
                        @change="$v.gasUsage.cost.$touch()"
                     />
                  </div>
               </validation-messages>

               <validation-messages label="kWh" :$v="$v.gasUsage.usage" v-if="quote.gasUsage.usageType == 1">
                  <label for="bothUsageGasUsage" class="sr-only">Gas Usage</label>
                  <div class="input-group right">
                     <form-field
                        id="bothUsageGasUsage"
                        type="number"
                        v-model="quote.gasUsage.usage"
                        :error="$v.gasUsage.usage.$error"
                        @change="$v.gasUsage.usage.$touch()"
                     />
                     <div class="input-group-addon">kWh</div>
                  </div>
               </validation-messages>
            </div>

            <div class="col-sm-5 _margin-bottom-10">
              <label for="bothUsageGasUsageUnit" class="sr-only">Gas Units</label>
              <select-list
                 id="bothUsageGasUsageUnit"
                 v-model="quote.gasUsage.usageUnit"
                 :list="usageUnitList"
                 @change="onGasUnitChange"
              />
            </div>
         </div>

         <h6 class="_margin-bottom-10">
           Electricity <button type="button" class="btn-i" v-if="quote.electricityUsage.usageType == 1" v-uiv-tooltip.right="'You will find your electricity consumption on your latest bill'">i</button>
           <button type="button" class="btn-i" v-if="quote.electricityUsage.usageType == 0" v-uiv-tooltip.right="'You will find your electricity spend on your latest bill'">i</button>
         </h6>
         <div class="row">
            <div class="col-sm-4 _margin-bottom-10">
               <label for="bothUsageElectrictyUsageType" class="sr-only">Electricity Usage Type</label>
               <select-list
                  id="bothUsageElectrictyUsageType"
                  v-model="quote.electricityUsage.usageType"
                  :list="usageTypeList"
                  :disabled="true"
               />
            </div>

            <div class="col-xs-12 col-sm-3 _margin-bottom-10">
               <validation-messages
                  label="Spend"
                  :$v="$v.electricityUsage.cost"
                  v-if="quote.electricityUsage.usageType == 0">

                  <label for="bothUsageElectrictyCost" class="sr-only">Electricity Cost</label>
                  <div class="input-group left">
                     <div class="input-group-addon">£</div>
                     <form-field
                        id="bothUsageElectrictyCost"
                        type="number"
                        v-model="quote.electricityUsage.cost"
                        :error="$v.electricityUsage.cost.$error"
                        @change="$v.electricityUsage.cost.$touch()"
                     />
                  </div>
               </validation-messages>

               <validation-messages
                  label="kWh"
                  :$v="$v.electricityUsage.usage"
                  v-if="quote.electricityUsage.usageType == 1">

                  <label for="bothUsageElectrictyUsage" class="sr-only">Electricity Usage</label>
                  <div class="input-group right">
                     <form-field
                        id="bothUsageElectrictyUsage"
                        type="number"
                        v-model="quote.electricityUsage.usage"
                        :error="$v.electricityUsage.usage.$error"
                        @change="$v.electricityUsage.usage.$touch()"
                     />
                     <div class="input-group-addon">kWh</div>
                  </div>
               </validation-messages>
            </div>

            <div class="col-sm-5">
              <label for="bothUsageElectrictyUsageUnit" class="sr-only">Electricity Units</label>
              <select-list
                 id="bothUsageElectrictyUsageUnit"
                 v-model="quote.electricityUsage.usageUnit"
                 :list="usageUnitList"
              />
            </div>
         </div>
      </uiv-tab>

      <uiv-tab title="Help Me Estimate">
          <div class="row" v-show="quote.gasUsage.usage && quote.electricityUsage.usage">
              <div class="col-sm-4">
                  <h6 class="_margin-bottom-10">Gas Usage</h6>
                  <h4 class="_margin-top-0">{{ quote.gasUsage.usage | number }} <small>kWh</small></h4>
              </div>

              <div class="col-sm-4">
                  <h6 class="_margin-bottom-10">Electricity Usage</h6>
                  <h4 class="_margin-top-0">{{ quote.electricityUsage.usage | number }} <small>kWh</small></h4>
              </div>

              <div class="col-sm-12_margin-top-20">
                  <uiv-btn type="ghost"
                      size="sm"
                      @click="onEstimate">New Estimate</uiv-btn>
              </div>
          </div>

         <div v-show="!quote.gasUsage.usage && !quote.electricityUsage.usage">
            <p>We can provide you an annual consumption estimate by answering a few short questions</p>

            <uiv-btn type="ghost"
               size="sm"
               class="_margin-bottom-20"
               @click="onEstimate">Help Me Estimate</uiv-btn>
         </div>

         <help-me-estimate
            ref="helpEstimate"
            @onClose="onCloseModal" />
      </uiv-tab>

      <uiv-tab title="Use Ofgem Averages">
         <h6>Gas</h6>
         <div class="row _margin-bottom-30">
            <div class="col-xs-4 col-md-3" v-for="item in ofgemAverageList('gas')" :key="item.label">
               <radio-button v-model="quote.gasUsage.usage"
                            :error="$v.gasUsage.usage.$error"
                            :value="item.value">{{ item.label }}</radio-button>
            </div>
         </div>

         <h6>Electricity</h6>
         <div class="row">
            <div class="col-xs-4 col-md-3" v-for="item in ofgemAverageList()" :key="item.label">
               <radio-button v-model="quote.electricityUsage.usage"
                            :error="$v.electricityUsage.usage.$error"
                            :value="item.value">{{ item.label }}</radio-button>
            </div>
         </div>
      </uiv-tab>
   </uiv-tabs>
</div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import HelpMeEstimate from './HelpMeEstimate';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'Usage',
  data () {
    return {
      requesting: false,
      usageTab: 0,
      estimateModalOpen: false
    };
  },
  props: {
    $v: Object
  },
  computed: {
     ...mapGetters({
        is02Meter: 'quote/is02Meter'
     }),
     ...mapState({
        ofgemAverages: ({ ofgem_averages }) => ofgem_averages.averages,
        quote: ({ quote }) => quote,
        usageTypeList: ({ lookups }) => lookups.usageTypes,
        usageUnitList: ({ lookups }) => lookups.usageUnits,
        helpMeEstimate: ({ help_me_estimate }) => help_me_estimate.model,
        gasUsageProvided: ({ quote }) => {
           const address = quote.address.parts;
           if(!address) return false;
           const gasdetails = address.gasdetails.find(({ isDomestic }) => isDomestic) || {};
           return gasdetails.mpaq;
        }
     })
  },
  methods: {
    ...mapActions({
      initTabs: 'help_me_estimate_questions/getQuestions',
      getEstimateList: 'lookups/getEstimateList'
    }),
    onReset () {
      if(this.usageTab != 0) return;
      this.quote.gasUsage.usageUnit = 1;
      this.quote.electricityUsage.usageType = this.quote.gasUsage.usageType;

      this.quote.gasUsage.cost = '';
      this.quote.electricityUsage.usage = '';
      this.quote.electricityUsage.cost = '';

      if(!this.quote.gasUsage.usage && this.gasUsageProvided) {
         this.quote.gasUsage.usage = this.gasUsageProvided;
      } else {
         this.quote.gasUsage.usage = '';
      }
    },
    onEstimate () {
      this.$refs.helpEstimate.openModal();
    },
    onUsageTabChange (index) {
      if (index === 1) {
         this.getEstimateList();
      }

      if (index === 0) {
         this.onReset();
         this.onGasUnitChange();
      }

      if (index != 0) {
         this.quote.gasUsage.usageType = 1;
         this.quote.gasUsage.usage = '';
         this.quote.gasUsage.cost = '';
         this.quote.electricityUsage.usageType = 1;
         this.quote.electricityUsage.usage = '';
         this.quote.electricityUsage.cost = '';
         this.quote.gasUsage.usageUnit = 1;
         this.quote.electricityUsage.usageUnit = 1;
         this.$v.gasUsage.$reset();
         this.$v.electricityUsage.$reset();
      }
    },
    onGasUnitChange() {
      if(this.quote.gasUsage.usageType == 1 && this.quote.gasUsage.usageUnit == 1) {
         this.quote.gasUsage.usage = this.gasUsageProvided;
      } else {
         this.quote.gasUsage.usage = '';
      }
    },
    onCloseModal ({ gasUsage, electricityUsage }) {
      this.onReset();
      this.quote.gasUsage.usage = gasUsage;
      this.quote.electricityUsage.usage = electricityUsage;
    },
    ofgemAverageList (fuel) {
      if (fuel == 'gas') {
        return this.ofgemAverages.gas;
      }

      if (this.is02Meter) {
        return this.ofgemAverages.electricity02;
      }

      return this.ofgemAverages.electricity01;
    }
  },
  components: {
    RadioButton,
    HelpMeEstimate
  }
};
</script>

<style lang="scss">
</style>
